export interface MaterialDefinitionsSortParam {
    field: string;
    direction: 'asc' | 'desc';
}

export const materialDefinitionKeys = {
    all: ['material-definitions'] as const,
    lists: () => [...materialDefinitionKeys.all, 'list'] as const,
    list: (sort?: MaterialDefinitionsSortParam) =>
        [...materialDefinitionKeys.lists(), sort?.field ?? null, sort?.direction ?? null] as const,
    details: () => [...materialDefinitionKeys.all, 'detail'] as const,
    detail: (id: string) => [...materialDefinitionKeys.details(), id] as const,
    defaultQcRanges: (id: string) => [...materialDefinitionKeys.detail(id), 'default-qc-ranges'] as const,
};
